import React, { ReactElement, useState, useEffect } from 'react';
import { FormulaireCreationEntite, PropsDeCreationEntite } from '../Utils/FormulaireCreationEntite';
import { Categorie } from '../../../../../common/src/entities';
import { schemaCategorie } from '../../../../../common/src/schemas';
import { useAlertDialog } from '../../../Utils/dialogContext';
import { ChampsEtiquetteCategorie } from './ChampsEtiquetteCategorie';
import { Category } from './DragAndDropTable';
import FormulaireModificationEntite from '../Utils/FormulaireModificationEntite';

const ENTETE_CREER_INCONNU = "Création d'une nouvelle catégorie";
const ENTETE_CREER_CONNU = "Création d'une catégorie ";
const ALERT_CATEGORIE = 'Catégorie';
const ALERT_CREER_SUCESS = 'créé avec succès!';
const ALERT_MODIFIER_SUCESS = 'modifié avec succès!';

interface PropsCreerOuModifierCategorie extends Partial<PropsDeCreationEntite<Categorie>> {
    gereModificationCategorie?: (categorie: Categorie) => void;
    categorie?: Category; // Ajoutez ici le nouveau prop
    estEnModification?: boolean;
}

/**
 * Page de création d'une entité Catégorie contenant les boutons
 * du haut et le formulaire à remplir
 *
 * @returns page html du formulaire
 */
export default function CreerOuModifierCategorie(props: PropsCreerOuModifierCategorie): ReactElement {
    const bsAlert = useAlertDialog();
    const { categorie } = props; // Décomposez le nouveau prop ici
    const [valeursInitiales, setValeursInitiales] = useState<Categorie>(new Categorie());

    useEffect(() => {
        let title = 'Nouvelle Catégorie - Dashboard';
        if (valeursInitiales.name) {
            title = `${valeursInitiales.name} - Dashboard`;
        }
        document.title = title;
    }, [valeursInitiales.name]);

    /**
     * Affiche le titre en haut du formulaire de création d'un Categorie
     *
     * @param l entité Categorie
     * @returns html du titre
     */
    function texteEntete(categorie: Categorie): JSX.Element {
        return (
            <>
                <small className="text-muted">{categorie.name ? ENTETE_CREER_CONNU : ENTETE_CREER_INCONNU}</small>
                {categorie.name && categorie.name}
            </>
        );
    }

    /**
     * Callback pour un formulaire envoyé à la BD avec succès.
     * Affiche le popup de confirmation la première fois ensuite
     * seulement un crochet dans le bouton Sauvegarder
     *
     * @param categorie entité Cateorie
     */
    function gererSucces(categorie: Categorie): void {
        if (!props.estEnModification) {
            bsAlert(`${ALERT_CATEGORIE} ${categorie.name} ${ALERT_CREER_SUCESS}`, 'success');
        } else {
            bsAlert(`${ALERT_CATEGORIE} ${categorie.name} ${ALERT_MODIFIER_SUCESS}`, 'success');
        }
        setValeursInitiales(categorie);
        if (props.gereModificationCategorie) {
            props.gereModificationCategorie(categorie);
        }
    }

    return (
        <>
            {categorie ? (
                <FormulaireModificationEntite
                    id={Number(categorie.id)}
                    texteEntete={texteEntete}
                    entite={Categorie}
                    schema={schemaCategorie}
                    succes={gererSucces}
                    valeursInitiales={valeursInitiales}
                    {...props}
                >
                    <ChampsEtiquetteCategorie />
                </FormulaireModificationEntite>
            ) : (
                <FormulaireCreationEntite
                    texteEntete={texteEntete}
                    entite={Categorie}
                    schema={schemaCategorie}
                    succes={gererSucces}
                    valeursInitiales={valeursInitiales}
                    {...props}
                >
                    <ChampsEtiquetteCategorie />
                </FormulaireCreationEntite>
            )}
        </>
    );
}
